import * as React from 'react';
import ReactTable, { RowInfo } from 'react-table';
import { default as Renderers } from '../../sys/columns';
import { Card, Table } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { DataExportView } from '../../api';
import CustomPagination from '../../sys/pagination';

interface Props {
    refresh?: number;
    streams ?: string;
    timerange?: string | number;
    namespace?: string;
    metrics?: Array<string>;
}
interface State {
    data: any;
    currentStream: any;
}
export default class StreamStatsView extends React.Component<Props, State> {

    public static defaultProps: Partial<Props> = {
        streams: 'census and component',
        namespace: 'api.surveyor.abr',
        timerange: 'current',
        metrics: [
            'session.status',
            'session.statistics.cycle',
            'session.statistics.fifteen'
        ],
        refresh: 10000
    };
    protected columns = [{
            width: 15
        }, {
            Header: 'Stream',
            accessor: 'status.name',
            width: 280,
            Cell: (props: any) => this.statusNameRenderer(props)
        }, {
            Header: 'Stream Start Time',
            accessor: 'statistics.general.startTime',
            width: 180,
            Cell: (props: any) => Renderers.timestamp.format(props.value)
        }, {
            Header: 'Cycle Time',
            accessor: 'statistics.general.cycleTimeStart',
            width: 90,
            align: 'right',
            Cell: (props: any) => this.NARenderer(props.value)
        }, {
            Header: 'Active Secs',
            accessor: 'statistics.general.age',
            width: 130,
            align: 'right',
            Cell: (props: any) => this.activeSecRenderer(props.value)
        }, {
            Header: (h: any) => <span>Total VS<br/>Error<br/>Periods</span>,
            accessor: 'statistics.veristream.totals',
            width: 90,
            align: 'right',
            Cell: (props: any) => this.totalVSRenderer(props)
        }, {
            Header: (h: any) => <span>Availability<br/>15-Minute</span>,
            accessor: 'statistics.fifteen.general.erroredSecs',
            width: 90,
            align: 'right',
            Cell: (props: any) => this.availabilityRenderer(props)
        }, {
            Header: 'Media Files',
            columns: [{
                Header: 'Count',
                accessor: 'statistics.files.media.download.rate.samples',
                width: 70,
                align: 'right',
                Cell: (props: any) => Renderers.commaSeparated(props.value),
                aggregate: 'blank'
            }, {
                Header: 'Total KBytes',
                accessor: 'statistics.files.media.totalBytes',
                width: 100,
                align: 'right',
                Cell: (props: any) => Renderers.bytesToKB(props.value),
                aggregate: 'blank'
            }, {
                Header: () => <span>Bitrate<br/>(kbps)</span>,
                accessor: 'statistics.files.media.bitrate.current',
                width: 95,
                align: 'right',
                Cell: (props: any) => Renderers.bytesToKB(props.value),
                aggregate: 'blank'
            }, {
                Header: () => <span>Download<br/>Rate<br/>(kbps)</span>,
                accessor: 'statistics.files.media.download.rate.current',
                width: 70,
                align: 'right',
                Cell: (props: any) => Renderers.bytesToKB(props.value),
                aggregate: 'blank'
            }]
        }, {
            Header: () => <span>DVST<br/>(sec)</span>,
            accessor: 'statistics.timing.dvst',
            width: 80,
            align: 'right',
            Cell: (props: any) => Renderers.secToMsec(props.value),

        }, {
            Header: () => <span>Server IP<br/>Address<br/>Changes</span>,
            accessor: 'statistics.connection',
            width: 90,
            align: 'right',
            Cell: (props: any) => this.ipAddressChanges(props)
        }, {
            Header: () => <span>Sequence<br/>Errors</span>,
            accessor: 'statistics.files.media.sequence.errors',
            width: 90,
            align: 'right'
        }, {
            Header: () => (
                <div>
                    <div className="title">HTTP Status Errors</div>
                    <div className="http totals -header">
                        <div>3xx</div>
                        <div>4xx</div>
                        <div>5xx</div>
                    </div>
                </div>
            ),
            accessor: 'statistics.http',
            width: 180,
            align: 'center',
            className: 'group-first group-last',
            Cell: (props: any) => this.httpStatusRenderer(props)
        }, {
            Header: () => (
                <div>
                    <div className="title">HTTP Connection Errors</div>
                    <div className="http totals -header">
                        <div>Open</div>
                        <div>Close</div>
                        <div>Other</div>
                    </div>
                </div>
            ),
            accessor: 'statistics.http',
            width: 180,
            align: 'center',
            className: 'group-first group-last',
            Cell: (props: any) => this.httpConnectionRenderer(props)
    }];
    private updateTimer: number;

    componentWillUnmount() {
        if (this.updateTimer !== null)
            clearTimeout(this.updateTimer);
    }
    statusNameRenderer(props: any) {
        return (
            <div>
                <h1>
                    {props.original.status.name}
                </h1>
                <span>
                    {(props.original.status.mediaIP) ? (props.original.status.manifestIP + ' / ' + props.original.status.mediaIP) : props.original.statistics.connection.manifest.IPAddress}
              </span>
            </div>
        );
    }
    totalVSRenderer(props: any) {
        return props.original.statistics.veristream.totals[1];
    }
    httpStatusRenderer(props: any) {
        let value = props.original.statistics.http;
        return (
            <div
                className="totals"
                title="3xx, 4xx, 5xx http error counts"
            >
                <div className="http-3xx" title="3xx">{value.hsr3xx}</div>
                <div className="http-4xx" title="4xx">{value.hsce4xxTotal}</div>
                <div className="http-5xx" title="5xx">{value.hsse5xxTotal}</div>
            </div>
        );
    }
    httpConnectionRenderer(props: any) {
        let value = props.original.statistics.http;
        return (
            <div
                className="totals"
                title="3xx, 4xx, 5xx http error counts"
            >
                <div className="http-open" title="open"/>
                <div className="http-close outline" title="close">{value.close}</div>
                <div className="http-other outline" title="socket and other">{value.socketErrors}</div>
            </div>
        );
    }
    availabilityRenderer(props: any) {
        let erroredSec = props.original.statistics.fifteen.general.erroredSecs;
        let montoredSec = props.original.statistics.fifteen.general.monitoredSecs;
        if ((erroredSec === 0) && montoredSec > 0 )
            return '100.00';
        else {
            return (( erroredSec / montoredSec )  * 100).toFixed(2);
        }
    }
    ipAddressChanges(props: any) {
        let manifestIPChanges = props.original.statistics.connection.manifest.IPChanges;
        let mediaIPChanges = props.original.statistics.connection.media.IPChanges;
        let otherIPChanges = props.original.statistics.connection.other.IPChanges;

        return manifestIPChanges + mediaIPChanges + otherIPChanges;
    }
    NARenderer(props: any) {
        if (props === 0 || (props != null && typeof props === 'object')) {
            return 'N/A';
        }
        return props;
    }
    activeSecRenderer(props: any) {
        let minutes = Math.floor(props / 60);
        let seconds = props - minutes * 60;

        return props + ' [' + minutes + ':' + seconds + ']';
    }
    fetchData() {
        // tslint:disable-next-line:variable-name
        let __this = this;
        let url = 'http://default/api/analytics';
        axios.post(url, {
            streams: this.props.streams,
            timerange: this.props.timerange,
            namespace: this.props.namespace,
            metrics: this.props.metrics
        })
            .then(function (response: AxiosResponse) {
                if ((response.data.res >= 0 || response.data.res === undefined) && response.data.results !== undefined  ) {
                    if (response.data.results.session !== undefined) {
                        __this.setState({
                            data: DataExportView.transformData(response.data.results.session)
                        });
                    } else
                        // tslint:disable-next-line:no-console
                        console.log('expected array of sessions, got ', response.data.results);
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('request error: ', response.data);
                }
                __this.scheduleNextUpdate();
            })
            .catch(function (error: AxiosRequestConfig) {
                __this.scheduleNextUpdate();
            });
    }

    scheduleNextUpdate(ms ?: number) {
        if (ms === undefined)
            ms = this.props.refresh;
        this.updateTimer = setTimeout(() => this.fetchData(), ms);
    }

    componentWillMount() {
        Renderers.ReactTable(this.columns);
        this.setState({
            data: []
        });
    }
    getCard(name: string, unit: string, currValue: any, avgValue: any, maxValue: any, minValue: any) {
        return(
            <Card className="stream-stats-card">
                <Card.Content>
                    <Card.Header>
                        {name}
                    </Card.Header>
                    <Card.Meta>
                        {unit}
                    </Card.Meta>
                </Card.Content>
                <Card.Content extra>
                    <Table celled textAlign="right">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Cur.</Table.HeaderCell>
                                <Table.HeaderCell>Avg.</Table.HeaderCell>
                                <Table.HeaderCell>Max.</Table.HeaderCell>
                                <Table.HeaderCell>Min.</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>{currValue}</Table.Cell>
                                <Table.Cell>{avgValue}</Table.Cell>
                                <Table.Cell>{maxValue}</Table.Cell>
                                <Table.Cell>{minValue}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Card.Content>
            </Card>
        );
    }
    get2ColumnCard(name: string, unit: string, firstHeader: any, secondHeader: any, firstValue: any, secondValue: any) {
        return (
            <Card className="stream-stats-card-two">
                <Card.Content>
                    <Card.Header>
                        {name}
                    </Card.Header>
                    <Card.Meta>
                        {unit}
                    </Card.Meta>
                </Card.Content>
                <Card.Content extra>
                    <Table celled textAlign="right">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>{firstHeader}</Table.HeaderCell>
                                <Table.HeaderCell>{secondHeader}</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell>{firstValue}</Table.Cell>
                                <Table.Cell>{secondValue}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Card.Content>
            </Card>
        );
    }
    cardLayout() {

            return (
                <div className="stream-stats-panel">

                    {
                        this.getCard('Media File Download Bit Rate', '(Kbps)',
                                     (this.state.currentStream ? Renderers.bytesToKB(this.state.currentStream.statistics.files.media.download.rate.current) : '-'),
                                     (this.state.currentStream ? Renderers.bytesToKB(this.state.currentStream.statistics.files.media.download.rate.avg) : '-'),
                                     (this.state.currentStream ? Renderers.bytesToKB(this.state.currentStream.statistics.files.media.download.rate.max) : '-'),
                                     (this.state.currentStream ? Renderers.bytesToKB(this.state.currentStream.statistics.files.media.download.rate.min) : '-'),
                        )
                    }
                    {
                        this.getCard('Media File Size', '(bytes)',
                                     (this.state.currentStream ? Renderers.commaSeparated(this.state.currentStream.statistics.files.media.size.current) : '-'),
                                     (this.state.currentStream ? Renderers.commaSeparated(this.state.currentStream.statistics.files.media.size.avg) : '-'),
                                     (this.state.currentStream ? Renderers.commaSeparated(this.state.currentStream.statistics.files.media.size.max) : '-'),
                                     (this.state.currentStream ? Renderers.commaSeparated(this.state.currentStream.statistics.files.media.size.min) : '-')
                        )
                    }
                    {
                        this.getCard('Media File Bit Rate', '(Kbps)',
                                     (this.state.currentStream ? Renderers.bytesToKB(this.state.currentStream.statistics.files.media.bitrate.current) : '-'),
                                     (this.state.currentStream ? Renderers.bytesToKB(this.state.currentStream.statistics.files.media.bitrate.avg) : '-'),
                                     (this.state.currentStream ? Renderers.bytesToKB(this.state.currentStream.statistics.files.media.bitrate.max) : '-'),
                                     (this.state.currentStream ? Renderers.bytesToKB(this.state.currentStream.statistics.files.media.bitrate.min) : '-')
                        )
                    }
                    {
                        this.getCard('Media File Duration', '(sec)',
                                     (this.state.currentStream ? Renderers.secToMsec(this.state.currentStream.statistics.files.media.duration.current) : '-'),
                                     (this.state.currentStream ? Renderers.secToMsec(this.state.currentStream.statistics.files.media.duration.avg) : '-'),
                                     (this.state.currentStream ? Renderers.secToMsec(this.state.currentStream.statistics.files.media.duration.max) : '-'),
                                     (this.state.currentStream ? Renderers.secToMsec(this.state.currentStream.statistics.files.media.duration.min) : '-')
                        )
                    }
                    {
                        this.getCard('Media File Download Time', '(sec)',
                                     (this.state.currentStream ? Renderers.secToMsec(this.state.currentStream.statistics.files.media.download.time.current) : '-'),
                                     (this.state.currentStream ? Renderers.secToMsec(this.state.currentStream.statistics.files.media.download.time.avg) : '-'),
                                     (this.state.currentStream ? Renderers.secToMsec(this.state.currentStream.statistics.files.media.download.time.max) : '-'),
                                     (this.state.currentStream ? Renderers.secToMsec(this.state.currentStream.statistics.files.media.download.time.min) : '-')
                        )
                    }
                    {
                        this.getCard('Media File Round Trip Time', '(ms)',
                                     (this.state.currentStream ? Renderers.secToMsec(this.state.currentStream.statistics.files.media.roundTripTime.current) : '-'),
                                     (this.state.currentStream ? Renderers.secToMsec(this.state.currentStream.statistics.files.media.roundTripTime.avg) : '-'),
                                     (this.state.currentStream ? Renderers.secToMsec(this.state.currentStream.statistics.files.media.roundTripTime.max) : '-'),
                                     (this.state.currentStream ? Renderers.secToMsec(this.state.currentStream.statistics.files.media.roundTripTime.min) : '-')
                        )
                    }
                    {
                        this.getCard('Media File TCP Duplicate ACK', '',
                                     (this.state.currentStream ? this.state.currentStream.statistics.files.media.tcp.dupAck.current : '-'),
                                     (this.state.currentStream ? this.state.currentStream.statistics.files.media.tcp.dupAck.avg : '-'),
                                     (this.state.currentStream ? this.state.currentStream.statistics.files.media.tcp.dupAck.max : '-'),
                                     (this.state.currentStream ? this.state.currentStream.statistics.files.media.tcp.dupAck.min : '-')
                        )
                    }
                    {
                        this.getCard('Media File TCP Retransmissions', '',
                                     (this.state.currentStream ? this.state.currentStream.statistics.files.media.tcp.retPackets.current : '-'),
                                     (this.state.currentStream ? this.state.currentStream.statistics.files.media.tcp.retPackets.avg : '-'),
                                     (this.state.currentStream ? this.state.currentStream.statistics.files.media.tcp.retPackets.max : '-'),
                                     (this.state.currentStream ? this.state.currentStream.statistics.files.media.tcp.retPackets.min : '-')
                        )
                    }
                    {
                        this.getCard('VS', '',
                                     (this.state.currentStream ? this.state.currentStream.statistics.veristream.value.current : '-'),
                                     (this.state.currentStream ? this.state.currentStream.statistics.veristream.value.avg : '-'),
                                     (this.state.currentStream ? this.state.currentStream.statistics.veristream.value.max : '-'),
                                     (this.state.currentStream ? this.state.currentStream.statistics.veristream.value.min : '-')
                        )
                    }
                    {
                        this.get2ColumnCard('VS-ED', '',
                                            'Cur.',
                                            'Min.',
                                            (this.state.currentStream ? this.NARenderer(this.state.currentStream.statistics.veristream.errorDistance.current) : '-'),
                                            (this.state.currentStream ? this.NARenderer(this.state.currentStream.statistics.veristream.errorDistance.current) : '-')
                        )
                    }
                    {
                        this.get2ColumnCard('VS-EP', '',
                                            'Cur.',
                                            'Max.',
                                            (this.state.currentStream ? this.NARenderer(this.state.currentStream.statistics.veristream.errorPeriod.current) : '-'),
                                            (this.state.currentStream ? this.NARenderer(this.state.currentStream.statistics.veristream.errorPeriod.max) : '-')
                        )
                    }
                    {
                        this.get2ColumnCard('Availability 15-Min', '(sec)',
                                            'Errored',
                                            'Monitored',
                                            (this.state.currentStream ? this.state.currentStream.statistics.fifteen.general.erroredSecs : '-'),
                                            (this.state.currentStream ? this.state.currentStream.statistics.fifteen.general.monitoredSecs : '-')
                        )
                    }
                    {
                        this.get2ColumnCard('DNS Requests', '',
                                            'Server',
                                            'Cached',
                                            (this.state.currentStream ? this.NARenderer(this.state.currentStream.statistics.connection.dns.server) : '-'),
                                            (this.state.currentStream ? this.NARenderer(this.state.currentStream.statistics.connection.dns.cacheHits) : '-')
                        )
                    }
                    {
                        this.getCard('DNS Time', '(ms)',
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.dns.time.current) : '-'),
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.dns.time.avg) : '-'),
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.dns.time.max) : '-'),
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.dns.time.min) : '-')
                        )
                    }
                    {
                        this.getCard('Connection Time', '(ms)',
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.time.current) : '-'),
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.time.avg) : '-'),
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.time.max) : '-'),
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.time.min) : '-')
                        )
                    }
                    {
                        this.getCard('Buffer/Gear Change Risk Duration', '(sec)',
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.veristream.gearChange.risk.current) : '-'),
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.veristream.gearChange.risk.avg) : '-'),
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.veristream.gearChange.risk.max) : '-'),
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.veristream.gearChange.risk.min) : '-')
                        )
                    }

                    {
                        this.getCard('CDN Cache Hit Depth', '',
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.cache.hitDepth.current) : '-'),
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.cache.hitDepth.avg) : '-'),
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.cache.hitDepth.max) : '-'),
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.cache.hitDepth.min) : '-')
                        )
                    }
                    {
                        this.getCard('CDN Cache Miss Depth', '',
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.cache.missDepth.current) : '-'),
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.cache.missDepth.avg) : '-'),
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.cache.missDepth.max) : '-'),
                                     (this.state.currentStream ?  Renderers.secToMsec(this.state.currentStream.statistics.connection.cache.missDepth.min) : '-')
                        )
                    }
                </div>
            );

    }
    render() {

        return (
            <div className="view-content" id="streamStats">
                <div className="pageTitle">
                    <div className="page-title-block">
                        <div className="iq-temp-key-val">
                            <div className="iq-temp-val page-title-text">Stream Statistics</div>
                        </div>
                    </div>
                </div>
                {this.cardLayout()}
                <div className="view-clientarea">
                    <ReactTable
                        className="transaction-log -striped -highlight"
                        onFetchData={() => this.fetchData()}
                        data={(this.state && this.state.data) ? this.state.data : []}
                        columns={this.columns}
                        defaultSorted={[
                            {
                                id: 'statistics.general.startTime',
                                asc: true
                            }
                        ]}
                        getTrProps={ (state: any, rowInfo: RowInfo) => {
                            return {
                                onClick: () => {
                                   this.setState({
                                        currentStream: rowInfo.original
                                    });
                                }
                            };
                        }}
                        defaultPageSize={16}
                        PaginationComponent={CustomPagination}
                    />
                </div>
            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/monitoring/streamStats.tsx